import { Component, Input, OnInit } from '@angular/core';
import { RouteInfo } from './rds-sidebar.metadata';
import { RdsSidebarService } from './rds-sidebar.service';

@Component({
	selector: 'rds-sidebar',
	templateUrl: './rds-sidebar.component.html',
	styleUrls: ['./rds-sidebar.component.scss']
})
export class RdsSidebarComponent implements OnInit {

	@Input() hasMiniSidebar: boolean = true;
	@Input() appLogo: string = ''; 
	@Input() companyLogo: string = '';

	defaultMiniOpts: any = {
		has_apps: true,
		has_setting: true,
		has_help: true
	};
	nav_collapsed: boolean = false;
	menuItems: RouteInfo[] = [];
	showBackButton: boolean = false;
	isLoading : boolean = true;
	loadingTheme:any= {
		'height.px': 40,
		'border-radius': 0,
		'margin-bottom': 0,
		'background-color': '#d8d8d8'
	  };

	constructor(private $sidebar: RdsSidebarService) { }

	ngOnInit(): void {
		this.isLoading = true;
		this.$sidebar.changeMenu.subscribe(sidebar => {
			if (sidebar && sidebar.length) {
				sidebar.forEach(sb => {
					if (!sb.submenu) {
						sb.submenu = [];
					}
				});
				this.menuItems = sidebar;
			}
			this.isLoading = false;
		});
	}

	onEmitName(name: string) {
		this.$sidebar.sideBarEmitter.emit(name); 
		this.showBackButton = name ? true : false;
	}

}
